import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { HTTPRequestType, HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { DocumentReferenceType, Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import DocumentDetailsApp, { DocumentDetailsAppProps, DocumentDetailsEntity } from "../documentDetails/documentDetails.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter.js";
import HttpDocumentsService from "./http_document_service.js";
import { Button } from "../core/components/button.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { EventType } from "../../siteManagement/eventManager.js";
import { BasicDialog } from "../statistics/reactcomponent.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import DocumentFolderStructureTree from "./documentFolderStructureTree.js";
import { ExpandOnInitState, TreeData } from "../core/components/kendoTree.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { TextBox } from "../core/components/textBox.js";
import { ContainsLanguage } from "../generalSettings/editTranslationsInGrid.js";
import { Context, Entity, Metadata } from "../core/components/commonApp.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import DocumentsDetailsApp, { DocumentsDetailsAppProps } from "../documentDetails/documentsDetails.js";
import React from "react"
import ReactDOM from "react-dom";
export default class DocumentsListApp extends React.Component<DocumentsListAppProps, DocumentsState> {
    private _fileUploadElementRef = null;
    private _fileUploadRef: kendo.ui.Upload = null;
    private _gridRef: Grid = null;
    protected _gridId = "documents";
    private _preliminaryDocumentDokuTyp = 9;
    private _hyperlinkDokuTyp = 5;
    private _gridOptions: kendo.ui.GridOptions = {
        resizable: true,
        pageable: !Helper.useMobileGui(),
        sortable: true,
        filterable: true,
        selectable: "multiple, row"
    };
    private _data: Array<DocumentListItem> = [];
    private _btnDownloadId = "btnDownload";
    private _btnDownloadAllId = "btnDownloadAll";
    private _btnPreview = "btnPreview";
    private _btnPreviewInSheet = "btnPreviewInSheet";
    private _btnAddHyperLink = "btnAddHyperlink";
    private _btnAddFile = "btnAddFile";
    private _btnDeleteRelationship = "btnDeleteRelationship";
    private _btnChooseFile = "btnChooseFile";
    //private _btnSmartSearch = "btnSmartsearch";
    private _wrapperElementRef = null;
    private _forceReadOnly = false;
    private _topMostSheet: Sheet = null;
    private _configData: ConfigData = null;
    private _dragEvents = "drag dragstart dragend dragover dragenter drop";
    private _eventsRegistered = false;
    private _documentKeyVal1 = null;
    private _documentKeyVal2 = null;
    protected _additionalTypes: DokumentReference[] = null;
    private _enabled: boolean;
    private _factory = ComponentHelper.createFactory();
    private _urlRegex = /^[a-zA-Z0-9\-\_]+:\/\/.+$/;
    private httpDocumentsService: DocumentService;

    constructor(props: DocumentsListAppProps) {
        super(props);
        
        this._setEnabled(props);
        
        this._gridId = `documents_${props.type}`;
        this.state = {
            configLoaded: false,
            showPreview: false,
            document: null
        };
        this._addSheetEvents();
        this._setDocumentKeyValues();
        this._additionalTypes = this.props.additionalDocuments?.map(x => {
            return {
                Type: x.type,
                Table: x.table
            }
        });
        this.httpDocumentsService = props.documentService || new HttpDocumentsService();
    }


    private _setEnabled 
        = (props: DocumentsListAppProps) => {
        if (Helper.hasValue(props?.entity?.RecordRight)) 
            this._enabled = props?.entity?.RecordRight.CanWrite === true;
        else
            this._enabled = true;
    }

    private _addSheetEvents = () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data: { command: string }) => {
            if (data.command == "updateDocuments") {
                this._setDocumentKeyValues();
                this._setEnabled(this.props);
                this._fileUploadRef.enable(this.props.entity.RecordRight.CanWrite);
                this._getData().then();
            }
        })
    }

    private _loadConfig = async () => {
        const result = await this.httpDocumentsService.LoadConfig(this.props.type,
            this._getId(), this.props.table, !this._enabled);
        if (result.Code === 0) {
            this._configData = result.Data;
            this._createGrid();
            this.setState({ configLoaded: true }, this._afterConfigMount);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _getId = () => {
        let id = this._documentKeyVal1;
        if (this.props.type === 4) {
            id += "|" + this._documentKeyVal2;
        }
        return id;
    }

    private _getData = async (initialLoad: boolean = false, callback?: () => void) => {
        const result: JsonResultClass<DocumentListItem[]> = await this.httpDocumentsService.GetDocuments(this.props.type, this._documentKeyVal1, this._documentKeyVal2, this.props.table, this._additionalTypes);
        this._updateGridData(result.Data);
        if (!initialLoad) {
            this._topMostSheet.trigger(SheetEventType.Custom, { command: "documentsChanged" });
            this._topMostSheet.trigger(SheetEventType.Custom, { command: "updateDocumentsCount", count: result.Data.length });
        }
        this.setState({}, callback);
    }

    private _updateGridData = (newData: DocumentListItem[]) => {
        this._data = [];
        if (!newData) {
            return;
        }
        for (let i = 0; i < newData.length; i++) {
            this._data.push({
                Bemerkung: newData[i].Bemerkung,
                Dokuid: newData[i].Dokuid,
                Isguid: newData[i].Isguid,
                Dokutyp: newData[i].Dokutyp,
                Erstellt: newData[i].Erstellt,
                FileName: newData[i].FileName,
                Titel: newData[i].Titel,
                Verzeichnis: newData[i].Verzeichnis,
                Kategorie: newData[i].Kategorie,
                KategorieId: newData[i].KategorieId,
                CanWrite: newData[i].CanWrite,
                LocatedLocallyAtRessnr: newData[i].LocatedLocallyAtRessnr,
                SubKategId: newData[i].SubKategId,
                SubKategorie: newData[i].SubKategorie,
                VirtualFolder: newData[i].VirtualFolder,
                Geaendert: newData[i].Geaendert,
                Anlegelogin: newData[i].Anlegelogin,
                Geaendertlogin: newData[i].Geaendertlogin,
                DokumentReference: newData[i].DokumentReference,
                Context: newData[i].DokumentReference?.Name,
                Nurintern: newData[i].Nurintern,
                RefId: newData[i].RefId
            });
        }
    }

    private _getExistingFiles = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/Documents?multi=true&displayPattern=[[title]]&cus_Limited=true", null, { disableTabTitle: true });
        sheet.bind(SheetEventType.ItemsSelected, async (ev) => {
            let isGuids = ev.data.map((x: { isguid: any; }) => x.isguid);
            this._saveDocumentsRelationships(isGuids).then();
        });
    }

    private _saveDocumentsRelationships = async (isGuids: string[]) => {
        const result = await this.httpDocumentsService.SaveDocumentsRelationships(isGuids, this.props.type, this._documentKeyVal1, this._documentKeyVal2, this.props.table);
        if (result.Code == 0) {
            if (result.Message) {
                NotificationHelper.showSuccessMessage(result.Message);
            }
            this.triggerHistoryEventUpdate(isGuids);
            await this._getData();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private getIconClass = (item: DocumentListItem) => {
        const fileName = item.FileName;
        let iconClass = "fal fa-file";
        if (item.Dokutyp === this._hyperlinkDokuTyp) {
            iconClass = "fal fa-external-link"
        } else if (Helper.hasValue(fileName)) {
            const fileNameArr = fileName.split(".");
            const icons = fileIcons.filter(f => f.fileExtensions.indexOf(fileNameArr[fileNameArr.length - 1].toLocaleLowerCase()) > -1);
            if (icons.length > 0) {
                iconClass = icons[0].iconName;
            } else {
                iconClass = "fal fa-file-alt";
            }
        }
        return iconClass;
    }

    private _createTemplate = (item: DocumentListItem) => {
        const fileName = item.FileName;
        let iconClass = this.getIconClass(item);
        let data = {
            path: Helper.getValueOrDefault(fileName, Helper.getValueOrDefault(item.Verzeichnis, "")).replace(/\s/g,""),
            iconClass: iconClass
        };
        let template: (data: any) => string;
        if (item.Dokutyp == this._preliminaryDocumentDokuTyp) {
            let templateStr = Helper.getDefaultCellTemplate("path",`
                <div class="grid-icon" style="height: 20px">
                    <div style="padding-right: 20px">
                        <i class="fa-light fa-hourglass-start fa-lg" aria-hidden="true"></i>
                    </div>
                    <span style='overflow: hidden; text-overflow: ellipsis; white-space: nowrap;'>#=path#</span>
                </div>`);
            template = kendo.template(templateStr);
        } else {
            template = kendo.template(Helper.getDefaultCellTemplate("path",'<div class="grid-icon" style="height: 20px"><div style="padding-right: 20px"><i class="#=iconClass# fa-lg" aria-hidden="true"></i></div><span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">#=path#</span></div>'));
        }




        return template(data);
    }

    private _openEditWindow = async (id: string, savedSuccessfully?: (isGuid: string) => void) => {
        const sheet = General.Sheet.Manager.createSheet();

        const refId = this._documentKeyVal1 + (Helper.hasValue(this._documentKeyVal2) ? "|" + this._documentKeyVal2 : "");
        sheet.setTitle(this._configData.translations.Details);
        sheet.bind(SheetEventType.SavedSuccessfully, (_) => {
            this._getData();
        });
        const [result, metaData] = await Promise.all([
            this.httpDocumentsService.GetDocumentDetails(id, this.props.type, refId, this.props.table),
            Helper.getMetaData("documentDetails")
        ])

        if (result.Code != 0) {
            NotificationHelper.showErrorMessage(result.Message);
            return;
        }

        const details = result.Data;
        const defaults = this.props.onRequestDefaults && this.props.onRequestDefaults();
        if (defaults) {
            if (defaults.description) {
                details.Bemerkung = defaults.description;
            }
            if (defaults.title) {
                details.Titel = defaults.title;
            }
            if (defaults.descriptionReadOnly) {
                MetaDataHelper.setReadOnly(metaData, "entity.Bemerkung", true);
            }
        }

        const props: DocumentDetailsAppProps = {
            context: {
                key1: "dokuId",
                keyVal1: result.Data.DokuId,
                contextType: "documentDetails",
                key2: "table",
                keyVal2: this.props.table
            },
            title: null,
            entity: details,
            metadata: metaData,
            dataSources: {},
            isWindow: true,
            id: id.toString(),
            type: this.props.type,
            refId: refId,
            table: this.props.table,
            documentTreeActivated: this._configData.documentTreeActivated,
            documents: this._data
        };
        let isSaved = false;
        sheet.bind(SheetEventType.Close, () => {
            this._getData(!isSaved);
            if (isSaved && savedSuccessfully)
                savedSuccessfully(details.IsGuid);
        });

        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            isSaved = true;
        })

        sheet.show(() => {
            sheet.mountContent(DocumentDetailsApp, props);
        });
    }


    private getDoks(node: DocumentFolderStructure): string[] {
        let arr = [];

        if (node == null)
            return arr;
        const getInternal = (n: any) => {
            if (!n.IsDocument && n.Children.length > 0) {
                n.Children.forEach((n: any) => getInternal(n));
            } else {
                arr.push(n.Id);
            }
        }

        getInternal(node);

        return arr;
    }
    private handleSelectionChanged = (dataItem: any) => {
        if (dataItem) {
            if (this.state.showPreview && !this._isViewable(dataItem)) {
                this.setState({ document: dataItem, showPreview: false });
            } else {
                this.setState({ document: dataItem });
            }
        }
    }

    private _onButtonClick = (id: string, dataItem: DocumentListItem | DocumentListItem[]) => {
        this._handleRowSelectOrMultiselectClick(id, dataItem);

        if (Array.isArray(dataItem)) {
            this._handleMultiselctClick(id, dataItem as DocumentListItem[]);
        } else {
            this._handleRowSelectClick(id, dataItem as DocumentListItem);
        }
    }
    private _handleRowSelectClick = (id: string, dataItem: DocumentListItem) => {
        switch (id) {
            case this._btnDownloadId:
                if (dataItem.Dokutyp === this._hyperlinkDokuTyp) {
                    if (this._urlRegex.test(dataItem.Verzeichnis)) {
                        Helper.openInNewBrowserTab(dataItem.Verzeichnis);
                    } else if (dataItem.Verzeichnis.indexOf("file") === 0) {
                        try {
                            Helper.openFileInNewBrowserTab(dataItem.Verzeichnis);
                        } catch (e) {
                            NotificationHelper.showErrorMessage(this._configData.translations["BrowserNotAllow"]);
                        }
                    } else {
                        const getUrl = window.location;
                        const baseUrl = getUrl.protocol + "//" + getUrl.host + Config.baseUrl;
                        Helper.openInNewBrowserTab(baseUrl + dataItem.Verzeichnis);
                    }
                } else {
                    Helper.download(`${Config.baseUrl}Document/Download/${dataItem.Isguid}`, "newFile");
                }
                break;
            case this._btnPreview:
                this.setState({ showPreview: this.state ? !this.state.showPreview : true });
                break;
            case this._btnPreviewInSheet:
                const sheet = General.Sheet.Manager.createSheet();
                if (!Array.isArray(this.state.document)) {
                    const props: any = { filename: this.state.document.FileName, dokuGuid: this.state.document.Isguid, translations: this._configData.translations, handleEval: this.props.handleEval, additionalUrlParams: this.props.additionalUrlParams };
                    sheet.setTitle(Helper.getTranslation("Standard.Preview"));
                    sheet.show(() => {
                        sheet.mountContent(DocumentPreview, props);
                    });
                }
                break;
            case this._btnAddHyperLink:
                if (this.props.entity.RecordRight.CanWrite) {
                    this._openHyperLinkWindow().then();
                }
                break;
            case this._btnAddFile:
                if (this.props.entity.RecordRight.CanWrite) {
                    this._getExistingFiles();
                }
                break;
            case this._btnDeleteRelationship:
                if (this.props.entity.RecordRight.CanWrite) {
                    this._deleteRelationShip(dataItem.Dokuid, dataItem.Isguid).then();
                }
                break;
        }
    }

    private _handleRowSelectOrMultiselectClick = (id: string, dataItem: DocumentListItem | DocumentListItem[]) => {
        switch (id) {
            case this._btnDownloadAllId:
                let dataItems: DocumentListItem[] = [];
                try {
                    dataItems = $(`#${this._gridId}`).data().kendoGrid.dataSource.view();
                } catch {

                }
                this._downloadAsZip(dataItems);
                break;
            case this._btnChooseFile:
                this._triggerDocumentUpload();
                break;
        }
        if (dataItem) {
            //
        }
    }

    private _handleMultiselctClick = (id: string, dataItems: DocumentListItem[]) => {

        switch (id) {
            case this._btnDownloadId:
                this._downloadAsZip(dataItems);
                break;
            case this._btnAddHyperLink:
                if (this.props.entity.RecordRight.CanWrite) {
                    this._openHyperLinkWindow().then();
                }
                break;
            case this._btnAddFile:
                if (this.props.entity.RecordRight.CanWrite) {
                    this._getExistingFiles();
                }
                break;
            case this._btnDeleteRelationship:
                if (this.props.entity.RecordRight.CanWrite) {
                    const docIds = dataItems.map(doc => doc.Dokuid)
                        .filter((value, index, array) => {
                            return array.indexOf(value) === index;
                        });

                    const isGuids = dataItems.map(doc => doc.Isguid)
                        .filter((value, index, array) => {
                            return array.indexOf(value) === index;
                        });
                    this._deleteMultipleRelationShips(docIds, isGuids).then()
                }


                break;
        }
    }

    private _downloadAsZip = (dataItems: DocumentListItem[]) => {
        const ids = dataItems
            .filter(x => (x.Dokutyp !== this._hyperlinkDokuTyp && x.Dokutyp !== this._preliminaryDocumentDokuTyp))
            .map(x => x.Isguid)
            .join(";")
        const url = `${Config.baseUrl}Document/DownloadFiles?ids=${ids}`;
        if (Config.settings.isMobileApp)
            Helper.download(url, "newFile");
        else
            Helper.openInNewBrowserTab(url);
    }

    private _deleteRelationShip = async (Dokuid: any, isGuid: string = null) => {
        const isOK = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOK) {
            const result = await this.httpDocumentsService.DeleteRelationShip(Dokuid, this.props.type, this._documentKeyVal1, this._documentKeyVal2, this.props.table);
            if (result.Code == 0) {
                result.Message && NotificationHelper.showSuccessMessage(result.Message);
                if (isGuid != null)
                    this.triggerHistoryEventUpdate([isGuid]);
                await this._getData();
                this.setState({ showPreview: false });
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private _deleteMultipleRelationShips = async (dokuIds: number[], isGuids: string[] = []) => {
        const isOK = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOK) {
            let allDeleted = true;
            for (let i = 0; i < dokuIds.length; i++) {
                const result = await this.httpDocumentsService.DeleteRelationShip(dokuIds[i], this.props.type, this._documentKeyVal1, this._documentKeyVal2, this.props.table);
                allDeleted = allDeleted && (result.Code == 0);
            }
            if (allDeleted) {
                if (isGuids.length > 0)
                    this.triggerHistoryEventUpdate(isGuids);
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Dokument.DeleteMultipleLinks"));
            } else {
                NotificationHelper.showErrorMessage(Helper.getTranslation("Dokument.FileLinksNotDeleted"));
            }
            await this._getData();
        }
    }

    private _openHyperLinkWindow = async () => {
        const result = await this._openHyperlinkWindow();
        if (!Helper.isNullOrEmpty(result)) {
            const refId = this._documentKeyVal1 + (Helper.hasValue(this._documentKeyVal2) ? "|" + this._documentKeyVal2 : "");

            const hyperlinkResult = await this.httpDocumentsService.InitHyperlink(result, this.props.type, refId, this.props.table);
            if (hyperlinkResult.Code == 0) {
                this.triggerHistoryEventUpdate([hyperlinkResult.Data.IsGuid]);
                if (hyperlinkResult.Code === 0) {
                    await this._openEditWindow(hyperlinkResult.Data.IsGuid);
                } else {
                    NotificationHelper.showErrorMessage(hyperlinkResult.Message);
                }
            }
        }
    }

    private _openHyperlinkWindow = () => {
        return new Promise<string>((resolve) => {
            let value = "";
            const targetElement = $("<div>");
            $("body").append(targetElement);

            const dialogProps: DialogProps = {
                title: Config.translations.enterUrl,
                actions: [
                    {
                        label: Config.translations.cancel,
                        action: () => {
                            resolve(null)
                        }
                    },
                    {
                        label: Helper.getTranslation("WebSMS.Reminder.Add"),
                        action: () => {
                            const isOk = this._urlRegex.test(value)
                            if (isOk) {
                                resolve(value)
                            } else {
                                NotificationHelper.showWarningMessage(Helper.getTranslation("Dokument.EnterValidURl"));
                                return false;
                            }
                        },
                        primary: true
                    }
                ],
                afterClose: () => {
                    targetElement.remove();
                },
                width: 500
            };

            const textboxProps = this._factory.getDefaultTextBoxProps();
            textboxProps.value = value;
            textboxProps.onChange = (_, newValue) => {
                value = newValue
            }
            const root = ReactDOM["createRoot"](targetElement[0]);
            root.render(
                <>
                    <Dialog {...dialogProps} open={true}>
                        <TextBox {...textboxProps} />
                    </Dialog>
                </>);

        })
    }

    private _handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: DocumentListItem) => {
        if (type === ToolBarStandardButtonType.EDIT) {
            await this._openEditWindow(dataItem.Isguid, (id) => {
                this.triggerHistoryEventUpdate([id]);
            });
        } else if (type === ToolBarStandardButtonType.DELETE) {
            let referencesExist = await this.httpDocumentsService.CheckIfReferencesExists(dataItem.Isguid);
            let message = Config.translations.deleteMessage;
            if (referencesExist.Data) {
                message = this._configData.translations["ReferencesExist"];
            }
            let isOk = await DialogHelper.confirm(message);
            if (isOk) {
                const result = await this.httpDocumentsService.DeleteDocument(dataItem.Isguid, this.props.type, this._documentKeyVal1 + (Helper.hasValue(this._documentKeyVal2) ? "|" + this._documentKeyVal2 : ""));
                if (result.Code > 0) {
                    NotificationHelper.showErrorMessage(result.Message);
                } else {
                    await this._getData();
                }
            }
        }
    }

    private _checkUploadStatus = async (file: File, silent: boolean = false) => {
        if (file.name.split(".").length < 2 && file.size === 0) {
            let errorText = (this._configData.translations["NoValidType"] as string).replace("{name}", file.name);
            NotificationHelper.showErrorMessage(errorText);
        } else {
            const sendData: StringKeyDictionary<any> = {
                type: this.props.type,
                id: this._documentKeyVal1 + (Helper.hasValue(this._documentKeyVal2) ? "|" + this._documentKeyVal2 : ""),
                name: file.name,
                table: this.props.table
            };
            await this.httpDocumentsService.DocumentExists(this.props.type, this._documentKeyVal1, this._documentKeyVal2, file.name);
            sendData.file = file;
            await this._uploadFile(sendData, silent);
        }
    }

    private _uploadFile = async (data: any, silent: boolean = false) => {
        const formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const result = await this.httpDocumentsService.UploadDocument(formData)
        $(".k-upload-action.k-button.k-button-bare", this._wrapperElementRef).trigger("click");

        if (result.Code == 0) {
            this.triggerHistoryEventUpdate([result.Data]);
            await this._getData(false, () => {
                if (!silent)
                    this._openEditWindow(result.Data);
            });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private triggerHistoryEventUpdate = (isGuids: string[]) => {
        if (this.props.type == 2) {
            General.Events.trigger(EventType.Custom, { command: "historyEventUpdate", isGuids: isGuids });
        }
    }

    private _createGrid = () => {

        this._gridOptions.dataSource = {
            "schema": {
                "model": {
                    "fields": {
                        "Erstellt": { "type": "date" },
                        "Geaendert": { "type": "date" }
                    }
                }
            }
        };

        this._gridOptions.dataBound = (e) => {
            let grid = e.sender;
            let view = grid.dataSource.view();

            for (let i = 0; i < view.length; i++) {
                e.sender.items().map((_: number, row: any) => {
                    let dataItem: any = e.sender.dataItem(row);
                    if (dataItem.DokumentReference) {
                        let additionalDocument = this.props.additionalDocuments.find(x => x.type == dataItem.DokumentReference.Type && x.table == dataItem.DokumentReference.Table);
                        let backgroundColor = additionalDocument.backgroundColor;
                        $(row).css("background-color", backgroundColor);
                        $(row).prop("title", dataItem.DokumentReference?.Name);
                    }
                });
            }
        }

        if (Helper.hasValue(this.props.paging)) {
            const type = typeof this.props.paging;
            switch (type) {
                case "boolean":
                    this._gridOptions.pageable = this.props.paging as boolean;
                    if (this.props.paging) {
                        this._gridOptions.dataSource.pageSize = 100
                    }
                    break;
                case "bigint":
                case "number":
                    this._gridOptions.pageable = true;
                    this._gridOptions.dataSource.pageSize = (this.props.paging as number)
                    break;
            }
        }

        this._gridOptions.columns = [
            {
                field: "Dokuid",
                title: this._configData.translations.Dokuid,
                template: this.props.selectMode === true ? "<a href='\\#' class='document-instance'>#=Dokuid#</a>" : null,
                width: 100
            },
            {
                field: "Titel",
                title: this._configData.translations.Titel,
                width: 120
            },
            {
                field: "Kategorie",
                title: this._configData.translations.Kategorie,
                filterable: {
                    ui: this.categoryFilter
                },
                width: 120
            },
            {
                title: this._configData.translations.FileName,
                field: "FileName",
                template: this._createTemplate,
                width: 180
            },
            {
                field: "Nurintern",
                title: Helper.getTranslation("Field.Dokument.intern"),
                width: 130,
                template: ({ Nurintern }: any) => {
                    if (Nurintern === 1)
                        return Helper.getTranslation('Dokument.Intern');
                    return Helper.getTranslation('Dokument.Extern')

                },
                filterable: {
                    ui: (element: any) => {
                        element.kendoDropDownList({
                            dataTextField: "Text",
                            dataValueField: "Value",
                            dataSource: [{ Text: Helper.getTranslation('Dokument.Intern'), Value: 1 }, { Text: Helper.getTranslation('Dokument.Extern'), Value: 0 }],
                            optionLabel: Helper.getTranslation("Standard.BitteWählen")
                        });
                    }
                }

            },
            {
                field: "Bemerkung",
                title: this._configData.translations.Bemerkung,
                width: 120
            },
            {
                field: "Anlegelogin",
                title: Helper.getTranslation("WebSMS.Ticket.CreatedBy"),
                width: 120
            },
            {
                field: "Erstellt",
                title: this._configData.translations.Erstellt,
                template: "#= kendo.toString(kendo.parseDate(Erstellt), 'G') #",
                width: 110
            },
            {
                field: "Geaendertlogin",
                title: Helper.getTranslation("Field.Beleg.gename"),
                width: 130
            },
            {
                field: "Geaendert",
                title: Helper.getTranslation("WebSMS.Log.Geändert"),
                template: "#= kendo.toString(kendo.parseDate(Geaendert), 'G') ?? '' #",
                width: 110
            },
            {
                field: "Context",
                title: Helper.getTranslation("Field.Adresse.herkunft"),
                width: 120
            },
            {
                field: "MobileTemplate",
                template: this.mobileTemplate
            },
            {
                field: "RefId",
                hidden: true
            }
        ];

        if (Config.settings.useDocumentSubCategories) {
            this._gridOptions.columns.splice(2, 0, {
                field: "SubKategorie",
                title: Helper.getTranslation("Field.Dokument.Subcategory"),
                width: 150
            });
        }
    }

    private mobileTemplate = (item: DocumentListItem) => {
        let fileName = Helper.getValueOrDefault(item.FileName, Helper.getValueOrDefault(item.Verzeichnis, ""));
        let template = kendo.template(`<div class='list-item list-item--grid list-item--grid-icon-edit'>
            <i class='list-item__icon-inner ${this.getIconClass(item)}'></i>
            <div class='list-item__column'>
                <div class='list-item__text'>${fileName}</div>
                <div class='list-item__description list-item__text--ellipsis'>${item.Titel}</div>
                <div class='list-item__description'>#: Bemerkung ?? ''#</div>
                <div class='list-item__row' style='row-gap: 0.5em;'>
                    #if(data.Kategorie){#
                        <div class='list-item__tag'>#: Kategorie#</div>
              		    #}#
                    #if(data.SubKategorie){#
                        <div class='list-item__tag'>#: SubKategorie#</div>
              	    #}#
                </div>
            </div>
        </div>`);

        return template(item);
    }

    private categoryFilter = (element: any) => {
        let url = "DocumentLookup/GetCategories?permissionLevel=1";
        if (Helper.hasValue(this.props.type)) {
            url += `&dokumentReferenceType=${this.props.type}`
        }
        if (!Helper.isNullOrEmpty(this.props.table)) {
            url += `&table=${this.props.table}`
        }
        HTTPService.get(url).then(result => {
            element.kendoDropDownList({
                dataSource: result.map((k: { Value: any; }) => k.Value),
                optionLabel: Config.translations.pleaseSelect
            });
        });
    }
    private _getGridButtons = () => {
        const stdButtons: Array<ToolBarStandardButton> = [];
        const customButtons: Array<GridCustomToolBarButton> = [];
        if (this.state.configLoaded) {
            stdButtons.push({
                type: ToolBarStandardButtonType.EDIT,
                caption: Config.translations.editLabel,
                enabled: this.props.entity.RecordRight.CanWrite && !this._forceReadOnly && this._enabled && !Array.isArray(this.state.document) && this.state.document && this.state.document.CanWrite
            });

            const isPreliminaryDocument = Helper.hasValue(this.state.document) && !Array.isArray(this.state.document) && this.state.document.Dokutyp == this._preliminaryDocumentDokuTyp;

            let isHyperLink = false;
            if (Helper.hasValue(this.state.document) && !Array.isArray(this.state.document)) {
                let dokuTyp = Helper.getValueOrDefault(this.state.document.Dokutyp, 0);
                isHyperLink = (dokuTyp === this._hyperlinkDokuTyp)
            }

            customButtons.push({
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("Dokument.Choose"),
                enabled: this.props.entity.RecordRight.CanWrite && !this._forceReadOnly && this._enabled,
                id: this._btnChooseFile,
                iconClass: "fal fa-upload"
            })

            customButtons.push({
                autoEnabledOnRecordSelected: true,
                caption: isHyperLink ? this._configData.translations.Open : this._configData.translations.Download,
                enabled: !isPreliminaryDocument,
                id: this._btnDownloadId,
                iconClass: isHyperLink ? "k-i-hyperlink-open-sm" : "k-i-seek-s",
                useContextMenu: true
            });

            customButtons.push({
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebSMS.ReportMetadata.DownloadAll"),
                enabled: Helper.hasValue(this._data) && this._data.filter(f => (f.Dokutyp != this._hyperlinkDokuTyp && f.Dokutyp != this._preliminaryDocumentDokuTyp)).length > 0,
                id: this._btnDownloadAllId,
                iconClass: "fal fa-folder-download"
            });

            if (this.props.enableAddLink ?? true) {
                customButtons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: this._configData.translations.AddHyperLink,
                    enabled: this.props.entity.RecordRight.CanWrite && !this._forceReadOnly && this._enabled,
                    id: this._btnAddHyperLink,
                    iconClass: "k-i-launch"
                });
            }
            if (!Config.user.isExternal) {
                customButtons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: this._configData.translations.AddExisting,
                    enabled: this.props.entity.RecordRight.CanWrite && !this._forceReadOnly && this._enabled,
                    id: this._btnAddFile,
                    iconClass: "k-i-add"
                });
            }
            if (!this.props.disableRemoveRelationship) {
                customButtons.push({
                    autoEnabledOnRecordSelected: true,
                    caption: this._configData.translations.DeleteRelationship,
                    enabled: this.props.entity.RecordRight.CanWrite && !this._forceReadOnly && this._enabled && Helper.hasValue(this.state.document) && ((!Array.isArray(this.state.document) && this.state.document.CanWrite) || (Array.isArray(this.state.document)/* && this.state.document.filter(doc => !doc.CanWrite).length != 0*/)),
                    id: this._btnDeleteRelationship,
                    iconClass: "k-i-minus",
                    useContextMenu: true
                });
            }
            

            if (!isHyperLink && !Array.isArray(this.state.document)) {

                const enablePreviewButton: boolean = !Array.isArray(this.state.document) && this._isViewable(this.state.document);
                customButtons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: !this.state || !this.state.showPreview ? this._configData.translations.ShowPreview : this._configData.translations.HidePreview,
                    enabled: enablePreviewButton && !isPreliminaryDocument,
                    id: this.props.previewInNewSheet || Helper.useMobileGui() ? this._btnPreviewInSheet : this._btnPreview,
                    iconClass: "k-i-seek-s",
                    useContextMenu: true
                });
            }
        }
        return { stdButtons, customButtons };
    }

    private _isViewable = (dataItem: DocumentListItem | DocumentListItem[]) => {
        let result: boolean = false;
        if (Array.isArray(dataItem)) {
            const dokuid = dataItem[0].Dokuid;
            for (let i = 0; i < dataItem.length; i++) {
                if (dokuid != dataItem[i].Dokuid) {
                    return false;
                }
            }
            dataItem = dataItem[0];
        }


        if (Helper.hasValue(dataItem)) {
            const fileName = Helper.getValueOrDefault(dataItem.FileName, "");
            const extension = fileName.indexOf(".") != -1 ? fileName.split('.').pop().toUpperCase() : null;

            result = (extension == SupportedExtensions.Msg || extension == SupportedExtensions.Eml ||
                extension == SupportedExtensions.Jpeg || extension == SupportedExtensions.Jpg || extension == SupportedExtensions.Png ||
                extension == SupportedExtensions.Bmp || extension == SupportedExtensions.Gif || extension == SupportedExtensions.Pdf ||
                extension == SupportedExtensions.Txt || extension == SupportedExtensions.Xml || extension == SupportedExtensions.Sql || extension == SupportedExtensions.Json)
            if (!result) {
                console.log({ dataItem, fileName, extension })
            }
        }
        return result;
    }

    private _onDragEvent = (e: JQuery.Event) => {
        e["originalEvent"]["dataTransfer"].dropEffect = 'copy';
        if (!this._forceReadOnly) {
            e.preventDefault();
            e.stopPropagation();
            $(this._wrapperElementRef).css('border', '2px solid #0B85A1');
        }
    }

    private _onDragLeave = (e: JQuery.Event) => {
        if (!this._forceReadOnly) {
            e.preventDefault();
            e.stopPropagation();
            $(this._wrapperElementRef).css('border', '');
        }
    }

    private _onDrop = async (e: JQuery.TriggeredEvent) => {
        if (this.props.entity.RecordRight.CanWrite) {
            $(this._wrapperElementRef).css('border', '');
            if (!this._forceReadOnly) {
                let dataTransfer = (e.originalEvent as DragEvent).dataTransfer;
                // AP: Das neue Outlook erlaubt noch kein Drag and Drop von Mails und Attachments über den Browser -> Meldung für Aufklärung des Users
                if(dataTransfer.types.includes('maillistrow') && dataTransfer.files.length === 0){
                    DialogHelper.alert(Helper.getTranslation("Dokument.NewOutlookDragAndDropWarning"));
                    return;
                }
                if (Config.settings.useDocumentAddWithCanCancel) {
                    const id = this._documentKeyVal1 + (Helper.hasValue(this._documentKeyVal2) ? "|" + this._documentKeyVal2 : "");
                    const files: File[] = [];
                    for (let i = 0; i < dataTransfer.files.length; i++)
                        files.push((e.originalEvent as DragEvent).dataTransfer.files[i]);

                    await uploadDocuments(this.httpDocumentsService, files, this.props.type, id, true, async (ids) =>  {
                        $(".k-upload-action.k-button.k-button-bare", this._wrapperElementRef).trigger("click");

                        if (Array.isArray(ids)) {
                            this.triggerHistoryEventUpdate(ids);
                            await this._getData(false, () => {
                            });
                        }
                    }, this.props.table);

                } else {

                    const silent = dataTransfer.files.length > 1;
                    for (let i = 0; i < dataTransfer.files.length; i++) {
                        this._checkUploadStatus(dataTransfer.files[i], silent).then();
                    }
                }
            }
        }

    }

    private _registerEvents = () => {
        if (this._configData.rights.canWrite && !this._eventsRegistered) {
            $(this._wrapperElementRef).on(this._dragEvents, this._onDragEvent).on("dragleave", this._onDragLeave).on('drop', this._onDrop);
            this._eventsRegistered = true;
        }
    }

    private _deregisterEvents = () => {
        $(this._wrapperElementRef).off(this._dragEvents, this._onDragEvent).off("dragleave", this._onDragLeave).off('drop', this._onDrop);
        this._eventsRegistered = false;
    }

    private _afterConfigMount = () => {
        this._registerEvents();

        if (this.props.selectMode) {
            $(this._wrapperElementRef).on("click", ".document-instance", (e) => {
                const row = $(e.target).closest("tr");
                const doc = this._gridRef.getDataItem(row[0]);
                const sheet = General.Sheet.Manager.getTopMostSheet();
                sheet.trigger(SheetEventType.RowClicked, doc);
                sheet.hide();
            });
        }

        this._fileUploadRef = $(this._fileUploadElementRef).kendoUpload({
            enabled: this.props.entity.RecordRight.CanWrite,
            multiple: true,
            showFileList: false,
            select: async (e) => {
                if (Helper.hasValue(e.files)) {
                    if (Config.settings.useDocumentAddWithCanCancel) {
                        const id = this._documentKeyVal1 + (Helper.hasValue(this._documentKeyVal2) ? "|" + this._documentKeyVal2 : "");
                        const files: File[] = [];

                        for (let i = 0; i < e.files.length; i++)
                            files.push((e.files[i] as any).rawFile);

                        await uploadDocuments(this.httpDocumentsService, files, this.props.type, id, true, async (ids) =>  {
                            $(".k-upload-action.k-button.k-button-bare", this._wrapperElementRef).trigger("click");

                            if (Array.isArray(ids)) {
                                this.triggerHistoryEventUpdate(ids);
                                await this._getData(false, () => {
                                });
                            }
                        }, this.props.table);
                    }
                    else {
                        const silent = e.files.length > 1;
                        const files = e.files;
                        for (let i = 0; i < files.length; i++) {
                            await this._checkUploadStatus((files[i] as any).rawFile, silent);
                        }
                    }
                }
            }
        }).data("kendoUpload");
        this._disableKendoUploadDropZone();

        this._getData(true).then();
    }

    private _disableKendoUploadDropZone = () => {
        let parent = this._fileUploadRef.element.parent().parent().parent();
        parent.css("display", "none");
    }

    private _triggerDocumentUpload = () => {
        this._fileUploadRef.element.trigger("click")
    }

    private _setDocumentKeyValues = () => {
        this._documentKeyVal1 = this.props.context.keyVal1;
        this._documentKeyVal2 = this.props.context.keyVal2;

        if (typeof this.props.handleEval === "function") {
            if (Helper.hasValue(this.props.documentKeyVal1)) {
                this._documentKeyVal1 = this.props.handleEval(this.props.documentKeyVal1);
            }
            if (Helper.hasValue(this.props.documentKeyVal2)) {
                this._documentKeyVal2 = this.props.handleEval(this.props.documentKeyVal2);
            }
        }
    }


    private _updateEvent = (cus: { cmd: string, data: any }) => {
        if (cus.cmd === "refreshDocuments") {
            this._getData().then();
        }
    }

    private _setEvents = () => {
        this._topMostSheet = General.Sheet.Manager.getTopMostSheet();
        this._topMostSheet.bind(SheetEventType.Custom, (cus) => {
            if ((cus.command === "projectStatusChanged") && (this.props.context.contextType === "project")) {
                this._enabled = cus.value;
                this.setState({});
            }
        });

        General.Events.bind(EventType.Custom, this._updateEvent);

        if (this.props.type === DocumentReferenceType.Ticket) {
            if (this.props.entity.RecordRight.CanWrite)
                $(window).on("toggleDocumentUpload", (_, d) => {
                    this._fileUploadRef.enable(d.allow);
                    this._forceReadOnly = !d.allow;
                    this._configData.rights.canWrite = d.allow;
                    if (d.allow) {
                        this._registerEvents();
                    } else {
                        this._deregisterEvents();
                    }
                    this.setState({});
                });
        }

        if (this.props.type === DocumentReferenceType.TravelReport) {
            $(window).on("toggleDocumentUpload", (_, d) => {
                this._fileUploadRef.enable(d.allow);
                this._forceReadOnly = !d.allow;
                this._configData.rights.canWrite = d.allow;
                if (d.allow) {
                    this._registerEvents();
                } else {
                    this._deregisterEvents();
                }
                this.setState({});
            });
        }
    }

    private _checkEditability = () => {
        if (this.props.context.contextType === "project") {
            this._enabled = this.props.entity.ProjectStatus.Editing;
            this.setState({});
        }
    }

    componentDidMount() {
        this._loadConfig().then();
        this._checkEditability();
        this._setEvents();
    }

    componentWillUnmount() {
        this._deregisterEvents();
    }
    private onTreeSelectionChanged = (dataItem: DocumentFolderStructure, parentNode: DocumentFolderStructure, start: Date, end: Date) => {

        if (this._gridRef == null)
            return;

        const andfilter = { logic: "and", filters: [] };
        if (Helper.hasValue(start)) {
            andfilter.filters.push({ operator: "gte", field: "Erstellt", value: Helper.dates.toDate(start) });
        }

        if (Helper.hasValue(end)) {
            andfilter.filters.push({ operator: "lte", field: "Erstellt", value: Helper.dates.toDate(end) });
        }

        if (dataItem == null) {
            if (andfilter.filters.length > 0) {
                this._gridRef.getGridRef().dataSource.filter(andfilter);
            }

            return;
        }

        const node = dataItem.IsDocument ? parentNode : dataItem;

        const orfilter = { logic: "or", filters: [] };
        if (!dataItem.IsRootFolder || (node != null && !node.IsRootFolder)) {
            const arr = this.getDoks(node);
            if (arr.length != this._gridRef.getGridRef().dataSource.data().length)
                arr.forEach(f => orfilter.filters.push({ operator: "eq", field: "RefId", value: f }));
        }

        if (andfilter.filters.length == 0 && orfilter.filters.length == 0) {
            this._gridRef.getGridRef().dataSource.filter({});
        }
        else {
            if (andfilter.filters.length > 0 && orfilter.filters.length > 0) {
                andfilter.filters.push(orfilter);
                this._gridRef.getGridRef().dataSource.filter(andfilter);
            } else {
                if (andfilter.filters.length > 0) {
                    this._gridRef.getGridRef().dataSource.filter(andfilter);
                }
                if (orfilter.filters.length > 0) {
                    this._gridRef.getGridRef().dataSource.filter(orfilter);
                }
            }
        }

        if (dataItem.IsDocument) {
            this.selectGridItem(dataItem.Id);
        }
    }

    private selectGridItem(refId: any) {
        let grid = this._gridRef.getGridRef();
        let data: any = grid.dataSource.data();
        let item = data.find((x: { RefId: string; }) => x.RefId == refId);
        this.setState({ document: item }, () => {
            const tr = $("[data-uid='" + item.uid + "']", grid.tbody);
            grid.clearSelection();
            grid.select(tr);
            grid.trigger("change");
        });
    }

    private getDocumentFolderStructureTree = () => {
        if (!Config.settings.useDocumentFolderStructure || !this._configData.documentTreeActivated || Helper.useMobileGui())
            return null;

        return <DocumentFolderStructureTree
            type={this.props.type}
            documents={this._data}
            withDocuments={true}
            onSelectionChanged={this.onTreeSelectionChanged}
            expandOnInitState={ExpandOnInitState.FirstNodes}
            showFilter={true}
            selectedDocument={Array.isArray(this.state.document) ? null : this.state.document} />;
    }

    private getCleanedUpData = () => {
        const replaceHash = (str: string) => {
            if (Helper.isNullOrEmpty(str)) {
                str = " ";
            }
            const arr = str.split("#")
            return arr.join("\\#");
        }

        let data: DocumentListItem[] = JSON.parse(JSON.stringify(this._data))
        for (let i = 0; i < data.length; i++) {
            data[i].FileName = replaceHash(data[i].FileName);
            data[i].Titel = replaceHash(data[i].Titel);
        }
        return data
    }

    render() {
        const { stdButtons, customButtons } = this._getGridButtons();
        const preview = this.state && this.state.showPreview && this.state.document && !Array.isArray(this.state.document) ? <DocumentPreview filename={this.state.document.FileName} dokuGuid={this.state.document.Isguid} handleEval={this.props.handleEval} additionalUrlParams={this.props.additionalUrlParams} /> : null;
        const previewApp = this.state && this.state.document && !Array.isArray(this.state.document) ? <DocumentPreview filename={this.state.document.FileName} dokuGuid={this.state.document.Isguid} handleEval={this.props.handleEval} additionalUrlParams={this.props.additionalUrlParams} showOverflowY={false} /> : null;
        const fileUpload = (< input ref={(r) => this._fileUploadElementRef = r} type="file" />);

        return (
            <div className={"flex-container flex-container__item"} ref={(r) => this._wrapperElementRef = r}>
                {
                    this.state.configLoaded ?
                        <>
                            {fileUpload}
                            <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={20} id={`documents_${this.props.type}`} rememberPercentage={true} >
                                {this.getDocumentFolderStructureTree()}
                                <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={50} >
                                    <div className="flex-container__item flex-container flex-container--row">
                                        <Grid
                                            data={this.getCleanedUpData()}
                                            options={this._gridOptions}
                                            ref={(r) => this._gridRef = r}
                                            id={this._gridId}
                                            customButtons={customButtons}
                                            onClickCustomButton={this._onButtonClick}
                                            standardButtons={stdButtons}
                                            onClickStandardButton={this._handleClickStandardButton}
                                            onSelectionChanged={this.handleSelectionChanged}
                                            gridDetails={{
                                                useFeature: true,
                                                children: previewApp
                                            }}
                                            useFloatingButtons={true}
                                            copyCellValue={true}
                                        />
                                    </div>
                                    {preview}
                                </RSplitter>
                            </RSplitter>
                        </>
                        : null
                }
            </div>
        );
    }
}

export async function uploadDocument(docService: HttpDocumentsService, file: File, type: DocumentReferenceType, id: string, silent: boolean, savedSuccessfully: (data: any) => void) {
    const httpDocumentsService = docService ? docService : new HttpDocumentsService();
    
    const uploadFile = async (data: any) => {
        const formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const result = await httpDocumentsService.UploadDocument(formData);
        if (result.Code == 0) {
            if (!silent)
                await openEditWindow(result.Data);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    let openEditWindow = async (documentId: string) => {
        const sheet = General.Sheet.Manager.createSheet();

        sheet.setTitle(Config.translations.details);

        sheet.bind(SheetEventType.Close, (data) => {
            console.log("openEditWindow::Close - data: ", data);
            if (savedSuccessfully)
                savedSuccessfully(data);
        });

        let result = await HTTPService.chainBatch
            .add<JsonResultClass>(`Document/Init?id=${documentId}&type=${type}&refid=${encodeURIComponent(id)}`)
            .add<Metadata>(Helper.getMetaData("documentDetails"))
            .add<JsonResultClass<ConfigData>>(`Document/Index?type=${type}&id=${encodeURIComponent(id)}`)
            .promise();
        
        const props: DocumentDetailsAppProps = {
            context: { key1: "", keyVal1: null, contextType: "documentDetails" },
            title: null,
            entity: result[0].Data,
            metadata: result[1],
            dataSources: {},
            isWindow: true,
            id: documentId,
            type: type,
            refId: id,
            documentTreeActivated: result[2].Data?.documentTreeActivated ?? false
        };
        
        sheet.show(() => {
            sheet.mountContent(DocumentDetailsApp, props);
        });
    }

    const sendData: StringKeyDictionary<any> = {
        type: type,
        id: id,
        name: file.name
    };
    
    //await httpDocumentsService.DocumentExists(type, id, null, file.name)
    sendData.file = file;
    await uploadFile(sendData);
}

export async function uploadDocuments(docService: HttpDocumentsService, files: File[], type: DocumentReferenceType, id: string, canCancel: boolean, savedSuccessfully: (data: any) => void, table: string = "") {
    const httpDocumentsService = docService ? docService : new HttpDocumentsService();

    const uploadFiles = async () => {
        const data = new FormData();
        for (const f of files)
            data.append("files", f);
        data.append("type", type as any);
        data.append("id", id);
        if (canCancel)
            data.append("cancelable", "true")

        const result = await httpDocumentsService.UploadDocuments(data);
        if (result.Code == 0) {
            await openEditWindow(result.Data);
        } else {
            try{
                const messages: string[] = JSON.parse(result.Message);
                messages.forEach(message => {
                    NotificationHelper.showErrorMessage(message);
                });
            }catch(error){
                console.error(error);
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    const openEditWindow = async (documentIds: string[]) => {
        const sheet = General.Sheet.Manager.createSheet();
        let isInMemory = false;
        let saved = false;
        
        sheet.setTitle(Config.translations.details);

        sheet.bind(SheetEventType.Close, () => {
            //console.log("openEditWindow::Close - data: ", data);
            if (isInMemory && !saved) {
                documentIds.forEach((id: string) => {
                    httpDocumentsService.DeleteDocument(id, type, null)
                })
            }
            if (savedSuccessfully)
                savedSuccessfully(documentIds);
        });
     
        sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
            saved = true;
        })

        let result = await HTTPService.chainBatch
            .add<JsonResultClass>({
                data: {ids: documentIds, type: type, refid: id, table: table},
                url: "Document/InitMultiple",
                type: HTTPRequestType.Post
            })
            .add<Metadata>(Helper.getMetaData("documentsDetails"))
            .add<JsonResultClass<ConfigData>>(`Document/Index?type=${type}&id=${encodeURIComponent(id)}&table=${encodeURIComponent(table)}`)
            .add<any>("DocumentLookup/GetStatus")
            .add<any>(`DocumentLookup/GetCategories?currentId=0&dokumentReferenceType=${encodeURIComponent(type)}&table=${encodeURIComponent(table)}`)
            .add<any>("DocumentLookup/GetSubCategories")
            .add<JsonResultClass<DocumentFolderStructureTreeVm>>({
                data: { type: encodeURIComponent(type), },
                url: `DocumentFolderStructure/GetDocumentsTreeData`,
                type: HTTPRequestType.Post
            })
            .promise();
        
        const memRights = httpDocumentsService.GetRights();
        if (memRights && result[2].Data) {
            result[2].Data.rights.canRead = memRights.canRead;
            result[2].Data.rights.canWrite = memRights.canWrite;
            isInMemory = true;
        }

        const gridData = result[0].Data ?? [];
        gridData?.forEach((g: { SubKategId: number; }) => {
            if (g.SubKategId == 0)
                g.SubKategId = null;
        })

        const pathsList: any[] = [];
        const setPathsList = (pathsList: any[], items: DocumentFolderStructure[]) => {
            for (let item of items) {
                pathsList.push({path: item.TranslatedFolder});
                setPathsList(pathsList, item.Children);
            }
        }

        setPathsList(pathsList, result[6].Data.TreeData)

        const props: DocumentsDetailsAppProps = {
            context: {key1: "", keyVal1: null, contextType: "documentDetails"},
            title: null,
            entity: {
                DocumentsDetails: gridData,
                IsNew: true,
                RecordRight: {
                    CanRead: result[2].Data?.rights.canRead,
                    CanWrite: result[2].Data?.rights.canWrite,
                    CanWritePermissionDeniedReason: ""
                },
                IsWatchable: false,
                IsWatched: false
            },
            metadata: result[1],
            dataSources: {
                docStatus: result[3],
                docCategories: result[4],
                docSubCategories: result[5],
                pathsList: pathsList
            },
            isWindow: true,
            ids: documentIds,
            type: type,
            refId: id,
            table: table,
            documentTreeActivated: result[2].Data?.documentTreeActivated ?? false,
            subCategoryVisible: Config.settings.useDocumentSubCategories === true,
            folderVisible: Config.settings.useDocumentFolderStructure === true
        };

        sheet.show(() => {
            sheet.mountContent(DocumentsDetailsApp, props);
        });
    }
    //await httpDocumentsService.DocumentsExists(type, id, null, files.map(f => f.name))
    await uploadFiles()
}



interface PreviewProps {
    dokuGuid: string;
    filename: string;
    isChatLayout?: any;
    contextType?: string;
    entityId?: any;
    additionalUrlParams: string,
    handleEval?: any;
    showOverflowY?: boolean;
}

interface DocumentPreviewProps {
    dokuGuid: string;
    isChatLayout?: any;
    contextType?: string;
    entityId?: any;
    showOverflowY?: boolean;
}

interface EmailPreviewProps extends DocumentPreviewProps {
    additionalUrlParams: string;
}

interface DocumentsState {
    configLoaded: boolean;
    showPreview: boolean;
    document: DocumentListItem | DocumentListItem[];
}

enum SupportedExtensions {
    Msg = "MSG",
    Eml = "EML",
    Jpg = "JPG",
    Jpeg = "JPEG",
    Png = "PNG",
    Bmp = "BMP",
    Gif = "GIF",
    Pdf = "PDF",
    Txt = "TXT",
    Xml = "XML",
    Sql = "SQL",
    Json = "JSON"
}

export class DocumentPreview extends React.Component<PreviewProps, any>{
    private getAdditionalUrlParams = (): string => {
        if (this.props.additionalUrlParams) {
            if (this.props.handleEval) {
                try {
                    return this.props.handleEval(this.props.additionalUrlParams);
                } catch (e) {

                }
            }
            return this.props.additionalUrlParams
        }
        return null;
    }

    render() {
        const fileName = Helper.getValueOrDefault(this.props.filename, "");
        const extension = fileName.indexOf(".") != -1 ? fileName.split('.').pop().toUpperCase() : null;

        const isChatLayout = this.props.isChatLayout;

        if (extension == SupportedExtensions.Msg || extension == SupportedExtensions.Eml) {
            return !isChatLayout ? <MsgPreview key={this.props.dokuGuid} dokuGuid={this.props.dokuGuid} contextType={this.props.contextType} entityId={this.props.entityId} additionalUrlParams={this.getAdditionalUrlParams() || ''} /> : <EmbeddedPreview><MsgPreview key={this.props.dokuGuid} dokuGuid={this.props.dokuGuid} contextType={this.props.contextType} entityId={this.props.entityId} additionalUrlParams={this.getAdditionalUrlParams() || ''} /></EmbeddedPreview>;
        }
        else if (extension == SupportedExtensions.Jpeg || extension == SupportedExtensions.Jpg || extension == SupportedExtensions.Png || extension == SupportedExtensions.Bmp || extension == SupportedExtensions.Gif) {
            return <ImagePreview key={this.props.dokuGuid} dokuGuid={this.props.dokuGuid} isChatLayout={isChatLayout} />;
        }
        else if (extension == SupportedExtensions.Pdf) {
            return !isChatLayout ? <PdfPreview key={this.props.dokuGuid} dokuGuid={this.props.dokuGuid} /> : <EmbeddedPreview><PdfPreview key={this.props.dokuGuid} dokuGuid={this.props.dokuGuid} /> </EmbeddedPreview>;
        }
        else if (extension == SupportedExtensions.Txt || extension == SupportedExtensions.Xml || extension == SupportedExtensions.Sql || extension == SupportedExtensions.Json) {
            return <PlainTextPreview key={this.props.dokuGuid} dokuGuid={this.props.dokuGuid} isChatLayout={this.props.isChatLayout} showOverflowY={this.props.showOverflowY} />;
        }
        else if (extension) {
            return (!this.props.isChatLayout) ? <div>{Helper.getTranslation("WebSMS.Documents.NoPreview")}</div> : null;
        }
        return null;
    }
}

// @ts-ignore
class EmbeddedPreview extends React.Component<React.PropsWithChildren, { showPreview: boolean }>{
    // @ts-ignore
    constructor(props: React.PropsWithChildren) {
        super(props);
        this.state = { showPreview: false };
    }

    handleOpenPreview = () => {
        this.setState({ showPreview: true });
    }

    renderDialog = () => {
        const height = screen.availHeight * 0.8;
        return <BasicDialog
            title={Helper.getTranslation("WebSMS.Documents.ShowPreview")}
            onClose={() => this.setState({ showPreview: false })}
            height={height}>
            {this.props.children}
        </BasicDialog>
    }

    render() {
        return <>{this.state.showPreview ? this.renderDialog() : null}
            <a onClick={this.handleOpenPreview}> {Helper.getTranslation("WebSMS.Documents.ShowPreview")}</a>
        </>
    }
}

class MsgPreview extends React.Component<EmailPreviewProps, any>{
    private iFrame: HTMLIFrameElement;
    constructor(props: EmailPreviewProps) {
        super(props)
    }

    async componentDidMount() {
        const result = await HTTPService.get(`Document/GetMsgOrEmlPreview/?documentguid=${this.props.dokuGuid}`);
        const iFrameDoc = this.iFrame.contentWindow.document;
        this.setState({ message: result });
        iFrameDoc.open();
        iFrameDoc.write(result.html);
        iFrameDoc.close();
        this.iFrame.contentWindow.addEventListener('mouseup', this.dispatchIframeEvents.bind(this, 'mouseup'))
        this.iFrame.contentWindow.addEventListener('mousemove', this.dispatchIframeEvents.bind(this, 'mousemove'))
    }

    private dispatchIframeEvents = (eventName: string, event: MouseEvent) => {
        const clRect = this.iFrame.getBoundingClientRect();
        const evt: any = new CustomEvent(eventName, { bubbles: true, cancelable: false });
        evt.clientX = event.clientX + clRect.left;
        evt.clientY = event.clientY + clRect.top;
        evt.button = event.button;
        evt.which = event.which;
        document.dispatchEvent(evt);
    }

    private openMailFunctionFactory = (answerToAll: boolean) => {
        return () => {
            let url = Config.baseUrl + `EmailSender/New?respondeToMailId=${this.props.dokuGuid}&answerToAll=${answerToAll}`;
            if (!Helper.isNullOrEmpty(this.props.contextType)) {
                url += `&type=${this.props.contextType}`;
            }
            if (Helper.hasValue(this.props.entityId)) {
                url += `&itemKey=${this.props.entityId}`;
            }
            Helper.openInNewBrowserTab(url + this.props.additionalUrlParams);
        }
    }

    private forward = () => {
        let url = Config.baseUrl + `EmailSender/Forward?respondeToMailId=${this.props.dokuGuid}`;
        if (!Helper.isNullOrEmpty(this.props.contextType)) {
            url += `&type=${this.props.contextType}`;
        }
        if (Helper.hasValue(this.props.entityId)) {
            url += `&itemKey=${this.props.entityId}`;
        }
        Helper.openInNewBrowserTab(url);
    }

    private getRecipients() {
        let recipients = [];
        if (this.state && this.state.message && this.state.message.recipients && this.state.message.recipients.length > 0) {
            this.state.message.recipients.forEach((r: { Type: number; DisplayName: string | any[]; Email: string; }) => {
                if (r.Type == 1) {
                    const to = Helper.hasValue(r.DisplayName) && r.DisplayName.length > 0 ? '"' + r.DisplayName + '" ' + r.Email : r.Email;
                    recipients.push(to);
                }
            });
        }
        return recipients.length > 0 ? recipients.join(', ') : null;
    }

    render() {
        const cc = this.state && this.state.message &&
            this.state.message.cc && Array.isArray(this.state.message.cc) ? this.state.message.cc.join(', ') : null;

        const recipients = this.getRecipients();

        /*
        const sentOnDate = this.state && this.state.message  ?  Helper.dates.getDateFromJsonString(this.state.message.sentOn) : null;
        const sentOn = sentOnDate != null ? kendo.toString(kendo.parseDate(sentOnDate), 'G') : null;
        <div className="field__value"><div className="field__value__label"><label>To</label></div><div className="field__value__content"><div style={{ marginTop: "10px" }}>{sentOn != null ? sentOn : '...'}</div><div className="k- invalid - msg" data-for="Ticket- Nr."></div></div></div>
        */


        return (
            <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
                <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
                        <div className="field__value"><div className="field__value__label"><label>Sender</label></div><div className="field__value__content"><div style={{ marginTop: "10px" }}>{this.state && this.state.message ? this.state.message.from : '...'}</div><div className="k- invalid - msg" data-for="Ticket- Nr."></div></div></div>
                        <div className="field__value"><div className="field__value__label"><label>Subject</label></div><div className="field__value__content"><div style={{ marginTop: "10px" }}>{this.state && this.state.message ? this.state.message.subject : '...'}</div><div className="k- invalid - msg" data-for="Ticket- Nr."></div></div></div>
                        <div className="field__value"><div className="field__value__label"><label>To</label></div><div className="field__value__content"><div style={{ marginTop: "10px" }}>{recipients ? recipients : '...'}</div><div className="k- invalid - msg" data-for="Ticket- Nr."></div></div></div>
                        <div className="field__value"><div className="field__value__label"><label>CC</label></div><div className="field__value__content"><div style={{ marginTop: "10px" }}>{cc ? cc : '...'}</div><div className="k- invalid - msg" data-for="Ticket- Nr."></div></div></div>
                    </div>

                    <Button handleClick={this.openMailFunctionFactory(false)} iconName={"arrow-turn-down-left"} iconStyle={{ transform: "scale(1, -1)" }} buttonStyle={{ borderRadius: "var(--rounded-left)", borderRight: "none", display: Helper.useMobileGui() ? "none" : "flex" }} title={Helper.getTranslation("WebCRM.Email.Respond")}></Button>
                    <Button handleClick={this.openMailFunctionFactory(true)} iconName={"arrows-turn-right fa-rotate-180 fa-flip-horizontal"} buttonStyle={{ borderRadius: "var(--rounded-right)", display: Helper.useMobileGui() ? "none" : "flex" }} title={Helper.getTranslation("WebCRM.Email.RespondToAll")}></Button>

                    {/*<Button handleClick={this.forward} iconName={"arrow-turn-right"} iconStyle={{ }} buttonStyle={{ borderRadius: "var(--border-radius)", marginLeft: "10px" }} title={Helper.getTranslation("WebCRM.Email.Forward")}></Button>*/}
                </div>
                <iframe style={{ flex: 1, height: "100%", width: "100%" }} ref={(e) => this.iFrame = e}></iframe>
            </div>
        )
    }
}

class ImagePreview extends React.Component<DocumentPreviewProps, { dialogOpen: boolean, dialogDokuGuid: string }>{

    constructor(props: DocumentPreviewProps) {
        super(props);
        this.state = {
            dialogDokuGuid: null,
            dialogOpen: false
        };
    }

    private _dialogProps: DialogProps = {
        title: Config.translations.imagePreview,
        actions: [],
        afterClose: () => {
            this._closeDialog();
        },
        closable: true
    };

    private _createDialog = () => {
        const DIALOG_HEADER_SIZE = 63;
        const DIALOG_BORDERS = 10;
        const DIALOG_PADDINGS = 32;
        const img = document.getElementById(this.props.dokuGuid) as HTMLImageElement;
        const maxHeight = (screen.availHeight * 0.8) - DIALOG_HEADER_SIZE - DIALOG_BORDERS;
        let height = img.naturalHeight;
        let width = img.naturalWidth;
        if (height > maxHeight) {
            const ratio = width / height;
            height = maxHeight;
            width = maxHeight * ratio;
        }

        const minWidth = screen.availWidth * 0.25;

        this._dialogProps.width = minWidth > (width + DIALOG_BORDERS) ? minWidth : (width + DIALOG_BORDERS);
        this._dialogProps.height = height + DIALOG_HEADER_SIZE + DIALOG_BORDERS + DIALOG_PADDINGS;
        this._dialogProps.maxHeight = height + DIALOG_HEADER_SIZE + DIALOG_BORDERS + DIALOG_PADDINGS;

        this._dialogProps.maxWidth = "calc(95vw)";
        this._dialogProps.maxHeight = "calc(95vh)"

        //this._dialogProps.width = Math.min(screen.availWidth / 100 * 80, img.naturalWidth);
        //this._dialogProps.height = Math.min(screen.availHeight / 100 * 80, img.naturalHeight + Math.min((screen.availWidth / 100 * 20) - 10, 50));

        ////Ich weiß nicht warum aber es hilft Kendo doing kendo stuff       
        //this._dialogProps.maxHeight = this._dialogProps.height;
        return (
            <div>
                <Dialog {...this._dialogProps} open={true}>
                    <img title={Config.translations.clickToClose} style={{ width: (width - DIALOG_PADDINGS) + "px", height: (height - DIALOG_PADDINGS) + "px", cursor: 'pointer' }} src={`${Config.baseUrl}Document/Download/${this.state.dialogDokuGuid}`} onClick={this._closeDialog} alt="" />
                </Dialog>
            </div>
        );
    }

    private _closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    private _openDialog = (Id: string) => {
        this.setState({ dialogOpen: true, dialogDokuGuid: Id });
    }


    render() {
        if (this.props.isChatLayout) {
            const dialog = this.state.dialogOpen ? this._createDialog() : null;

            return (
                <div style={{ height: "100%", overflow: "hidden", whiteSpace: "pre" }}>
                    <img title={Config.translations.clickToOpenFullscreen} id={`${this.props.dokuGuid}`} style={{ flexShrink: 0, maxWidth: "100%", height: "auto", cursor: 'pointer' }} src={`${Config.baseUrl}Document/Download/${this.props.dokuGuid}`}
                        onClick={() => this._openDialog(this.props.dokuGuid)} alt="" />
                    {dialog}
                </div>);
        } else
            return (<div style={{ height: "100%", overflow: "auto", whiteSpace: "pre" }} >
                <img style={{ flexShrink: 0, width: "100%" }} src={`${Config.baseUrl
                    }Document/Download/${this.props.dokuGuid}`} alt="" />
            </div>);
    }
}

class PlainTextPreview extends React.Component<DocumentPreviewProps, any>{
    async componentDidMount() {
        let result = await HTTPService.get(`Document/Download/${this.props.dokuGuid}`);
        if (typeof result === 'object') {
            result = JSON.stringify(result, null, 1);
        }
        if (this.props.isChatLayout) {
            if (result.length > 1000) {
                result = result.slice(0, 500) + "...\r\n\r\n<...>\r\n\r\n..." + result.slice(result.length - 500, result.length);
            }
        }
        this.setState({ text: result });
    }



    render() {
        const show_overflowY = this.props.isChatLayout || !(this.props.showOverflowY ?? true) ? "hidden" : "auto";

        return (
            <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", overflowX: "auto", overflowY: show_overflowY, whiteSpace: "pre", textAlign: "left", paddingTop: "5px" }}>
                {this.state ? this.state.text : null}

            </div>
        )
    }
}

class PdfPreview extends React.Component<DocumentPreviewProps, any>{
    private iFrame: HTMLIFrameElement;

    componentDidMount() {
        this.iFrame.onload = this.bindListeners;
    }

    bindListeners = () => {
        if (this.iFrame.contentWindow) {
            this.iFrame.contentWindow.addEventListener('mouseup', this.dispatchIframeEvents.bind(this, 'mouseup'));
            this.iFrame.contentWindow.addEventListener('mousemove', this.dispatchIframeEvents.bind(this, 'mousemove'));
        }
    }

    dispatchIframeEvents = (eventName: string, event: MouseEvent) => {
        const clRect = this.iFrame.getBoundingClientRect();
        const evt: any = new CustomEvent(eventName, { bubbles: true, cancelable: false });
        evt.clientX = event.clientX + clRect.left;
        evt.clientY = event.clientY + clRect.top;
        evt.button = event.button;
        evt.which = event.which;
        document.dispatchEvent(evt);
    }

    render() {
        return (
            <iframe ref={(e) => this.iFrame = e} style={{ flex: 1, height: "100%", width: "100%", display: "block" }} src={`${Config.baseUrl}pdfviewer/web/viewer.html?file=${Config.baseUrl}Document/Download/${this.props.dokuGuid}`} />
        )
    }
}

export interface DocumentFolderStructure extends TreeData, Entity {
    Id?: string;
    ParentId?: string;
    TemplateId?: number;
    OriginalDescription?: string;
    TranslatedDescription?: string;
    OriginalFolder?: string;
    TranslatedFolder?: string;
    IsRootFolder?: string;
    IsDocument?: string;
    Created?: Date;
    Children?: DocumentFolderStructure[];
    TranslationsLoaded?: boolean;
    Translations?: DocumentFolderStructureTranslation[];
}

export interface DocumentFolderStructureTranslation extends ContainsLanguage {
    Id?: string;
    TranslatedDescription?: string;
}
export interface DocumentFolderStructureTreeVm {
    TreeData?: DocumentFolderStructure[];
}

export interface DocumentsListAppProps {
    entity: any;
    context: Context;
    type: any/*Innosoft.Core.Utils.DocumentReferenceType*/;
    disableRemoveRelationship?: boolean;
    previewInNewSheet?: boolean;
    table?: string;
    documentKeyVal1?: any;
    documentKeyVal2?: any;
    selectMode?: boolean;
    handleEval?(expression: string, additional?: any);
    documentService?: DocumentService;
    enableAddLink?: boolean//Man kann den Button zum Hinzufügen von Links mit false ausblenden. Wurde für die Integration mit Classic eingebaut.  Default ist true.
    onRequestDefaults?: () => { title?: string, description?: string, descriptionReadOnly?: boolean },
    additionalUrlParams?: string;
    paging?: boolean | number;
    additionalDocuments?: any[];
}

export interface DocumentService {
    LoadConfig(type: any, id: any, table: string, readOnly: boolean): Promise<JsonResultClass<ConfigData>>
    GetDocuments(type: any, documentKeyVal1: any, documentKeyVal2, table: string, additionalTypes: DokumentReference[]): Promise<JsonResultClass<DocumentListItem[]>>
    SaveDocumentRelationship(dokuId: any, type: any, documentKeyVal1: any, documentKeyVal2: any, table: string): Promise<JsonResultClass>
    SaveDocumentsRelationships(isGuids: string[], type: any, documentKeyVal1: any, documentKeyVal2: any, table: string): Promise<JsonResultClass>
    GetDocumentDetails(dokuId: any, type: any, refId, table: string): Promise<JsonResultClass<DocumentDetailsEntity>>
    UploadDocument(formData: FormData): Promise<JsonResultClass>
    UploadDocuments(formData: FormData): Promise<JsonResultClass>
    DeleteRelationShip(dokuId: any, type: any, documentKeyVal1: any, documentKeyVal2: any, table: string): Promise<JsonResultClass>
    InitHyperlink(url: string, type: any, refId: any, table: string): Promise<JsonResultClass>
    DeleteDocument(dokuId: any, type: any, refId: any): Promise<JsonResultClass>
    DocumentExists(type: any, documentKeyVal1: any, documentKeyVal2: any, fileName): Promise<CheckIfExistsResult>
    DocumentsExists(type: any, documentKeyVal1: any, documentKeyVal2: any, fileNames: string[]): Promise<CheckIfExistsResult>
    CheckIfReferencesExists(isGuid: string): Promise<JsonResultClass<boolean>>
    GetRights(): any
}

export interface DocumentListItem {
    Dokuid: number;
    Isguid: string;
    Titel: string;
    Erstellt: Date;
    Bemerkung: string;
    FileName: string;
    Verzeichnis: string;
    Dokutyp: number;
    Kategorie: string;
    KategorieId: number;
    CanWrite: boolean;
    SubKategorie?: string;
    SubKategId?: number;
    LocatedLocallyAtRessnr: string;
    VirtualFolder?: string;
    Geaendert?: Date;
    Anlegelogin?: string;
    Geaendertlogin?: string;
    DokumentReference?: DokumentReference;
    Context?: string;
    Nurintern: number;
    RefId: string;
}

export interface DokumentReference {
    Type: string;
    Table?: string;
    Name?: string;
}

export interface CheckIfExistsResult {
    exists: boolean;
    multiple: boolean;
    id: number;
}

export interface ConfigData {
    rights: {
        canRead: boolean;
        canWrite: boolean;
        isExtern: boolean;
    };
    translations: {
        Dokuid: string;
        Titel: string;
        FileName: string;
        Bemerkung: string;
        Erstellt: string;
        Download: string;
        Details: string;
        UpdateExisting: string;
        AddAsNew: string;
        InvalidUrl: string;
        ShowPreview: string;
        HidePreview: string;
        Format: string;
        AddHyperLink: string;
        Open: string;
        DeleteRelationship: string;
        AddExisting: string;
        Kategorie: string;
    },
    documentTreeActivated?: boolean;
}

export const fileIcons: Array<{ iconName: string, fileExtensions: string[] }> = [
    {
        iconName: "fal fa-file-pdf",
        fileExtensions: [
            "pdf"
        ]
    },
    {
        iconName: "fal fa-file-image",
        fileExtensions: [
            "png", "bmp", "jpg", "jpeg", "jpe", "gif", "svg", "ico"
        ]
    },
    {
        iconName: "fal fa-file-video",
        fileExtensions: [
            "mp2", "mp3", "wav", "mp4", "viv", "avi", "movie"
        ]
    },
    {
        iconName: "fal fa-file-excel",
        fileExtensions: [
            "xlsx", "xls", "xla", "xlr", "xl"
        ]
    },
    {
        iconName: "fal fa-file-spreadsheet",
        fileExtensions: [
            "ods"
        ]
    },
    {
        iconName: "fal fa-file-csv",
        fileExtensions: [
            "csv"
        ]
    },
    {
        iconName: "fal fa-file-word",
        fileExtensions: [
            "doc", "docx", "odt"
        ]
    },
    {
        iconName: "fal fa-file-alt",
        fileExtensions: [
            "txt"
        ]
    },
    {
        iconName: "fal fa-file-archive",
        fileExtensions: [
            "zip", "7z", "rar"
        ]
    },
    {
        iconName: "fal fa-file-powerpoint",
        fileExtensions: [
            "ppt", "pptx", "odp"
        ]
    },
    {
        iconName: "fal fa-file-code",
        fileExtensions: [
            "html", "xml", "json"
        ]
    },
    {
        iconName: "fal fa-scroll",
        fileExtensions: [
            "js", "ts", "tsx"
        ]
    },
    {
        iconName: "fab fa-python",
        fileExtensions: [
            "py"
        ]
    },
    {
        iconName: "fal fa-envelope",
        fileExtensions: [
            "eml", "msg"
        ]
    }
];